import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ToolbarItem } from '../../../shared/interfaces/tool-bar-item.interface';
import { faAdd, faPlus, faSave, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';
import { INotificationService } from '../../../shared/services/inotification.service';
import { FeedbackMessageService } from '../../../shared/services/feedback-message.service';
import { DetailService } from '../../../core/services/detail.service';
import { BaseComponent } from '../../../core/models/base-component.model';
import { SVGIcon, arrowUpIcon, arrowDownIcon, trashIcon, xIcon, saveIcon, thumbUpIcon } from '@progress/kendo-svg-icons';
import { Item } from '../../../shared/interfaces/entities/item.interface';
import { CartService } from '../../../shared/services/cart.service';
import { Cart } from '../../../core/interfaces/cart.interface';
import { RedeploymentOrderAddress } from '../../../shared/interfaces/entities/redeployment-order-address.interface';
import { CountrySelect } from '../../../shared/ui/select-controls/country-select.model';
import { StateSelect } from '../../../shared/ui/select-controls/state-select.model';
import { ClientEngineerSelect } from '../../../shared/ui/select-controls/client-engineer-select.model';
import { RedeploymentOrder } from '../../../shared/interfaces/entities/redeployment-order.interface';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { RedeploymentOrderService } from '../../redeployment-orders/services/redeployment-order.service';
import { BooleanResult } from '../../../core/interfaces/boolean-result.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { NewOrder } from '../../../shared/interfaces/entities/new-order.interface';
import { last, takeUntil } from 'rxjs';
import { Services } from '../../../shared/literals/shared.literal';
import { AuthUserFilter } from '../../../shared/interfaces/select-filters/auth-user-filter.interface';
import { CountryFilter } from '../../../shared/interfaces/select-filters/country-filter.interface';
import { OnChangeArgs } from '../../../shared/components/select-field/select-field.component';
import { BaseControl } from '../../../shared/ui/controls/base-control.model';
import { SelectControl } from '../../../shared/ui/controls/select-control.model';
import { StateFilter } from '../../../shared/interfaces/select-filters/state-filter.interface';
import { CheckoutService } from '../services/checkout-service';
import { State } from '../../../shared/interfaces/entities/state-interface';
import { ShippingMethodSelect } from '../../../shared/ui/select-controls/shipping-method-select.model';
import { OverlayService } from '../../../shared/services/overlay.service';
import { EditEvent } from '@progress/kendo-angular-grid';
import { ListBoxToolbarConfig } from '@progress/kendo-angular-listbox';
import { DialogCloseResult, DialogRef, DialogService, DialogSettings } from '@progress/kendo-angular-dialog';
import { ShippingMethodFilter } from '../../../shared/interfaces/select-filters/shipping-method-filter.interface';
import { L2ProductAreaSelect } from '../../../shared/ui/select-controls/l2-product-select.model';
import { L3ProductAreaSelect } from '../../../shared/ui/select-controls/l3-product-select.model';
import { AuNumberSelect } from '../../../shared/ui/select-controls/au-number-model';

@Component({
    selector: 'app-checkout',
    templateUrl: './checkout.component.html',
    styleUrls: ['./checkout.component.css'],
    standalone: false
})
export class CheckoutComponent extends BaseComponent implements OnInit {


  /*@Input() entity: RedeploymentOrderAddress;*/
  redeploymentOrderAddressEntity: RedeploymentOrderAddress;
  redeploymentOrderEntity: RedeploymentOrder;

  @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();

  countryId: CountrySelect;
  stateId: StateSelect;
  shippingMethodId: ShippingMethodSelect;
  clientEngineerId: ClientEngineerSelect;

  l2ProductAreaId: L2ProductAreaSelect;
  l3ProductAreaId: L3ProductAreaSelect;
  auNumberId: AuNumberSelect;

  form: FormGroup;

  id: string;
  cartItems: any;
  cartMiscItems: any;
  timedOutCartItems: any;
  timedOutCartMiscItems: any;
  submitted: boolean = false;
  toolbarItems: ToolbarItem[] = [];

  labServicesChecked: boolean;
  labServiceRequired: boolean = false;

  labTrue: boolean = false;
  labFalse: boolean = false;

  hdrChecked: boolean = false;
  hdrRequired: boolean = false;

  shippingMethodRequired: boolean = false;

  openTimeout: boolean = false;

  dialogNo: SVGIcon = xIcon;
  dialogYes: SVGIcon = thumbUpIcon;
  dialogLoader: boolean = false;
  dialogIcon: boolean = true;

  addIcon = faAdd;

  public toolbarSettings: ListBoxToolbarConfig = {
    position: "right",
    tools: ["remove"],
  };

  public additionalEmail: string[] = [];
  public serialList: string[] = [];
  constructor(private activatedRouter: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private cartService: CartService,
    private auth: AuthenticationService,
    private notificationService: INotificationService,
    private orderService: RedeploymentOrderService,
    private checkoutService: CheckoutService,
    private cd: ChangeDetectorRef,
    private overlayService: OverlayService,
    private dialogService: DialogService) {
    super();

    var toolbarMoreActions: ToolbarItem = {
      text: 'More actions',
      icon: faSearch,
      hasMultiple: true
    };
    var toolbarCompleteOrder: ToolbarItem = {
      text: 'Complete Order',
      icon: faSave,
      hasMultiple: false,
      cssClass: 'primary',
      action: () => { this.onSubmit(); }
    };



    this.toolbarItems.push(/*toolbarMoreActions, */toolbarCompleteOrder);

    this.form = this.formBuilder.group({
        stateId: ['', Validators.required],
        countryId: ['', Validators.required],
        postalCode: ['', Validators.required],
        city: ['', Validators.required],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        shippingMethodId: [''],
        line1: ['', Validators.required],
        line2: [''],
        line3: [''],
        line4: [''],
        clientEngineerId: [null],
        l2ProductAreaId: [null],
        l3ProductAreaId: [null],
        auNumberId: [null],
        hdrNumber: [''],
        projectManagerEmail: [''],
        shippingInstructions: [''],
        siteDate: [null],
        additionalEmail: [''],
        benchTemplateEmails: [''],
        customerReferenceNumber: [''],
        organizationId: ['', Validators.required],
        notes: [''],
        createLabServices: [''],
        returningAssetSerial: [''],
        packageRecipientEmail: ['', Validators.required],
        company: [''],
        recipientPhone: ['', Validators.required],
        signatureRequired: [false]
    });


    this.activatedRouter.params.subscribe(params => this.id = params['id']);
  }

  ngOnInit(): void {
    var session = this.auth.getSession();
    if (session?.generateBenchTemplate == true) {
      this.labServiceRequired = true;

      // this.form.controls['projectManagerEmail'].addValidators(Validators.required);
      // this.form.controls['siteDate'].addValidators(Validators.required);
      // this.form.controls['clientEngineerId'].addValidators(Validators.required);
      // this.form.controls['customerReferenceNumber'].addValidators(Validators.required);
    } else {
      this.labServicesChecked = false;
    }

    if (session?.showHdrInfo == true) {
      this.hdrRequired = true;
    }

    if (session?.shippingMethodRequired == true) {
      this.shippingMethodRequired = true;
    }

    //The current cart items
    this.cartService.getCartItems().subscribe((data: any[]) => {
      this.cartItems = data;
    });

    //The current cart items
    this.cartService.getMiscellaneousItemCartItems().subscribe((data: any[]) => {
      this.cartMiscItems = data;
    });

    //The cart items that were removed due to timeout
    this.cartService.getTimedOutCartItems().subscribe((data: any[]) => {
      this.timedOutCartItems = data;

      this.cartService.getTimedOutCartMiscItems().subscribe((data: any[]) => {
        this.timedOutCartMiscItems = data;

        if (this.timedOutCartItems.length > 0 || this.timedOutCartMiscItems.length > 0) {
          this.openTimeoutDialog();
        }
      });
    });

    this.countryId = new CountrySelect("", "Country", null);

    var countryFilter: CountryFilter = {
      organizationId: this.auth.getOrganizationId()
    };

    this.countryId.filters = countryFilter;

    this.stateId = new StateSelect("", "State", null);
    this.shippingMethodId = new ShippingMethodSelect("", "Shipping Method", null);

    var shippingMethodFilter: ShippingMethodFilter = {
      organizationId: this.auth.getOrganizationId()
    };

    this.shippingMethodId.filters = shippingMethodFilter;
    this.clientEngineerId = new ClientEngineerSelect("", "Client Engineer", null);

    var clientEngineerFilters: AuthUserFilter = {
      organizationId: this.auth.getOrganizationId()
    };

    this.clientEngineerId.filters = clientEngineerFilters;
    //Set the HDR section to false
    this.l2ProductAreaId = new L2ProductAreaSelect("", "L2 Product Area", null);
    this.l3ProductAreaId = new L3ProductAreaSelect("", "L3 Product Area", null);
    this.auNumberId = new AuNumberSelect("", "Au Number", null);

    //if (session?.showHdrInfo) {
    //  this.form.controls['l2ProductAreaId'].addValidators(Validators.required);
    //  this.form.controls['l3ProductAreaId'].addValidators(Validators.required);
    //  this.form.controls['auNumberId'].addValidators(Validators.required);
    //}
  }

  get f() { return this.form.controls; }

  onSubmit() {

    if (this.stateId.singleValue == null) {
      this.form.controls['stateId'].setValue(null);
    } else {

      this.form.controls['stateId'].setValue(this.stateId.getValue());
    }

    var shippingMethodId = this.shippingMethodId.getNullableValue();
    var countryId = this.countryId.getValue();
    var clientEngineerId = this.clientEngineerId.getValue();
    var organizationId = this.auth.getOrganizationId();

    this.form.controls['countryId'].setValue(countryId);
    this.form.controls['organizationId'].setValue(organizationId.toString());
    this.form.controls['createLabServices'].setValue(this.labServicesChecked);

    this.form.controls['additionalEmail'].setValue(this.additionalEmail);

    if (this.labServicesChecked) {
      this.form.controls['clientEngineerId'].setValue(clientEngineerId);
    } else {
      this.form.controls['clientEngineerId'].setValue(null);
    }

    if (this.auth.getSession()?.showHdrInfo) {

      if (this.hdrChecked == false) {
        if (this.l2ProductAreaId.singleValue == null) {
          this.form.controls['l2ProductAreaId'].setValue(null);
        } else {

          this.form.controls['l2ProductAreaId'].setValue(this.l2ProductAreaId.getValue());
        }

        if (this.l3ProductAreaId.singleValue == null) {
          this.form.controls['l3ProductAreaId'].setValue(null);
        } else {

          this.form.controls['l3ProductAreaId'].setValue(this.l3ProductAreaId.getValue());
        }

        if (this.auNumberId.singleValue == null) {
          this.form.controls['auNumberId'].setValue(null);
        } else {

          this.form.controls['auNumberId'].setValue(this.l2ProductAreaId.getValue());
        }
      }

    } else {
      this.form.controls['l2ProductAreaId'].setValue(null);
      this.form.controls['l3ProductAreaId'].setValue(null);
      this.form.controls['auNumberId'].setValue(null);
    }

    if (this.shippingMethodRequired) {
      if (shippingMethodId != null) {
        this.form.controls['shippingMethodId'].setValue(shippingMethodId);
      } else {
        this.form.controls['shippingMethodId'].addValidators(Validators.required); //Only make this required if it is required via organization service
        this.form.controls['shippingMethodId'].setValue(null);
      }

      this.form.controls['returningAssetSerial'].setValue(this.serialList);

    } else {
      this.form.controls['shippingMethodId'].setValue(null);
      this.form.controls['returningAssetSerial'].setValue(null);
    }

    if (this.form.invalid == false && this.labServiceRequired == true && this.labServicesChecked == undefined) {
      //The User has NOT selected a choice here. We need one so let them know!
      this.notificationService.show({ type: 'error', title: "Error!", description: "You need to select whether you require lab services before continuing!" });
      return;
    }

    var data = this.form.value as NewOrder; //RedeploymentOrder

    this.submitted = true;

    // stop here if form is invalid
    if (this.form.invalid) {
      this.notificationService.show({ type: 'error', title: "Error!", description: "The form has errors! Please double check all required fields have been entered properly." });
      return;
    }

    var serialListLength = this.serialList.length;

    var labelList = this.cartMiscItems as Cart[];
    var labelQuantity = labelList.map(x => x.quantity).reduce((accumulator, currentValue) => accumulator + currentValue, 0);

    if (this.shippingMethodRequired && (serialListLength != labelQuantity)) {
      var e = window.event;
      e?.preventDefault();

      var options: DialogSettings = {
        title: "Are you sure?",
        animation: true,
        content: "The quantity of labels in your cart does not match the number of returning assets! Are you sure you wish to continue the order?",
        actions: [{ text: "No" }, { text: "Yes", themeColor: "primary" }],
        actionsLayout: "end",
        width: 525,
        height: 160
      };

      const dialog: DialogRef = this.dialogService.open(options);

      dialog.result.subscribe((result) => {
        var text: string = Reflect.get(result, 'text')
        if (text == "No" || result instanceof DialogCloseResult) {

        } else {
          this.overlayService.open();

          this.orderService.newOrder(data).subscribe((res => {

            //Remove the overlay no matter what
            this.overlayService.close();

            if (res.wasSuccessful) {
              this.cd.detectChanges();
              this.notificationService.show({ title: "Success!", type: "success", description: "A new order has been created!" });
              this.cd.detectChanges();
              //redirect to new order page
              this.router.navigate(['RedeploymentOrder/Detail/' + res.entity]);

            } else {

              //reload the page for the modal to pop up
              if (this.timedOutCartItems.length > 0 || this.timedOutCartMiscItems.length > 0) {
                window.location.reload();
              }

              //show validation errors
              var errors = res.errors;

              if (errors != null || errors != undefined) {
                for (var key in errors) {
                  var prop = key.charAt(0).toLowerCase() + key.slice(1);
                  var control = this.form.get(prop);
                  if (control) {
                    var list = "<ul class='validation-list'>";
                    var messages = errors[key].filter(e => !e.valid).map(m => "<li>" + m.message + "</li>").join("");
                    list += messages + "</ul>";
                    control.setErrors({ 'error': list });
                  }
                }
              } else {
                this.notificationService.show({ type: 'error', title: "Error!", description: res.message });
              }
            }
          }));
        }
      });
    } else {
      this.overlayService.open();

      this.orderService.newOrder(data).subscribe((res => {

        //Remove the overlay no matter what
        this.overlayService.close();

        if (res.wasSuccessful) {
          this.cd.detectChanges();
          this.notificationService.show({ title: "Success!", type: "success", description: "A new order has been created!" });
          this.cd.detectChanges();
          //redirect to new order page
          this.router.navigate(['RedeploymentOrder/Detail/' + res.entity]);

        } else {
        
          //reload the page for the modal to pop up
          if (this.timedOutCartItems.length > 0 || this.timedOutCartMiscItems.length > 0) {
            window.location.reload();
          }

          //show validation errors
          var errors = res.errors;

          if (errors != null || errors != undefined) {
            for (var key in errors) {
              var prop = key.charAt(0).toLowerCase() + key.slice(1);
              var control = this.form.get(prop);
              if (control) {
                var list = "<ul class='validation-list'>";
                var messages = errors[key].filter(e => !e.valid).map(m => "<li>" + m.message + "</li>").join("");
                list += messages + "</ul>";
                control.setErrors({ 'error': list });
              }
            }
          } else {
            this.notificationService.show({ type: 'error', title: "Error!", description: res.message });
          }
        }
      }));
    }
  }

  openTimeoutDialog() {
    this.openTimeout = true;
  }

  closeTimeoutDialog() {
    this.openTimeout = false;
  }

  acknowledgeTimedOutItems() {
    this.orderService.acknowledgeTimeoutItems().subscribe({
      next: (res: BooleanResult) => {
        if (res.wasSuccessful) {
          //redirect Home Page
          this.router.navigate(['/']);

        } else {
          var errors = res.errors;
          this.notificationService.show({ type: 'error', title: "Error!", description: res.message });
        }
      },
      error: (e: HttpErrorResponse) => {
        var errorMsg: string = e.error;
        if (typeof e.error === "object") {
          errorMsg = e.error.title
        }
        this.notificationService.show({ title: "Error!", type: "error", description: errorMsg ?? "Something Went Wrong!" });
      }
    });
  }

  onStatusChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;

    // inputElement.checked will return true when this specific option is selected
    if (inputElement.value == "true") {
      this.labServicesChecked = true;
      //Make sure these are required
      this.form.controls['projectManagerEmail'].addValidators(Validators.required);
      this.form.controls['siteDate'].addValidators(Validators.required);
      this.form.controls['clientEngineerId'].addValidators(Validators.required);
      this.form.controls['customerReferenceNumber'].addValidators(Validators.required);
    } else {
      //reset the lab services form so it won't fail submission!
      this.labServicesChecked = false;
      this.form.controls['projectManagerEmail'].removeValidators(Validators.required);
      this.form.controls['projectManagerEmail'].setErrors(null);

      this.form.controls['siteDate'].removeValidators(Validators.required);
      this.form.controls['siteDate'].setErrors(null);

      this.form.controls['clientEngineerId'].removeValidators(Validators.required);
      this.form.controls['clientEngineerId'].setErrors(null);

      this.form.controls['customerReferenceNumber'].removeValidators(Validators.required);
      this.form.controls['customerReferenceNumber'].setErrors(null);
    }
  }

  openLabServices(value: any) {
    this.labServicesChecked = value.target.checked;
    if (this.labServicesChecked == true) {
      //Make sure these are required
      this.form.controls['projectManagerEmail'].addValidators(Validators.required);
      this.form.controls['siteDate'].addValidators(Validators.required);
      this.form.controls['clientEngineerId'].addValidators(Validators.required);
      this.form.controls['customerReferenceNumber'].addValidators(Validators.required);
    } else {
      //reset the lab services form so it won't fail submission!

      this.form.controls['projectManagerEmail'].removeValidators(Validators.required);
      this.form.controls['projectManagerEmail'].setErrors(null);

      this.form.controls['siteDate'].removeValidators(Validators.required);
      this.form.controls['siteDate'].setErrors(null);

      this.form.controls['clientEngineerId'].removeValidators(Validators.required);
      this.form.controls['clientEngineerId'].setErrors(null);

      this.form.controls['customerReferenceNumber'].removeValidators(Validators.required);
      this.form.controls['customerReferenceNumber'].setErrors(null);

    }
  }

  openHdr(value: any) {
    this.hdrChecked = value.target.checked;
    if (this.hdrChecked == true) {
      //Make sure these are required
      this.form.controls['hdrNumber'].addValidators(Validators.required);

      /*  this.form.controls['l2ProductAreaId'].removeValidators(Validators.required);*/
      this.form.controls['l2ProductAreaId'].setErrors(null);

/*      this.form.controls['l3ProductAreaId'].removeValidators(Validators.required);*/
      this.form.controls['l3ProductAreaId'].setErrors(null);

/*      this.form.controls['auNumberId'].removeValidators(Validators.required);*/
      this.form.controls['auNumberId'].setErrors(null);

    } else {
      //reset the hdr services form so it won't fail submission!
      //this.form.controls['l2ProductAreaId'].addValidators(Validators.required);
      //this.form.controls['l3ProductAreaId'].addValidators(Validators.required);
      //this.form.controls['auNumberId'].addValidators(Validators.required);

      this.form.controls['hdrNumber'].removeValidators(Validators.required);
      this.form.controls['hdrNumber'].setErrors(null);
      this.form.controls['hdrNumber'].setValue('');

    }
  }

  addEmail(textBox: any): void {
    //Add to the list box...
    var emailToAdd = textBox.value;
    this.additionalEmail = [...this.additionalEmail, emailToAdd];
    textBox.value = "";
  }

  addReturningAssetSerial(textBox: any): void {
    //Add to the list box...
    var serialToAdd = textBox.value;
    this.serialList = [...this.serialList, serialToAdd];
    textBox.value = "";
  }


  onCountrySelectChange(obj: any): void {

    //Make State not required if the country is flagged to skip it
    var skipState = obj.value.skipState;
    if (skipState == true) {
      this.form.controls['stateId'].removeValidators(Validators.required);
      this.form.controls['stateId'].setErrors(null);

      this.cd.detectChanges();
    } else {
      this.form.controls['stateId'].addValidators(Validators.required);
    }

    var newValue = parseInt(obj.value.id);
    this.checkoutService.lookupState(newValue).subscribe({
      next: (data: Array<State>) => {
        if (data != undefined && data.length > 0) {
          this.stateId.data = data;
           // this.value.data = data;
            this.cd.detectChanges();
          }
        },
        error: (e: HttpErrorResponse) => {
          var errorMsg: string = e.error;
          if (typeof e.error === "object") {
            errorMsg = e.statusText
          }
          this.notificationService.show({ title: "Error!", description: errorMsg, type: "error" });
        }
      });
    }
  
}




